import { apiClient, toServiceError } from '@/services/http/client'
import { buildAuthUserFromClaims, decodeJwtClaims } from '@/services/auth/mappers'
import type { AuthLoginResult } from '@/services/auth'

export interface ClientTokens {
  access_token: string
  refresh_token?: string
  session_id?: string
}

/** Client ownership and consent always use the real authority, including in demo mode. */
export async function validateVaultTokens(
  data: ClientTokens,
  email = ''
): Promise<AuthLoginResult> {
  if (!data.access_token) throw new Error('Missing access token')
  const verified = await apiClient.post('/auth/verify', {
    token: data.access_token,
    destination_service: 'client-vault',
  })
  if (!verified.data.valid || !verified.data.claims)
    throw new Error('Session could not be verified')
  const claims = verified.data.claims
  return {
    user: buildAuthUserFromClaims(claims, email),
    token: data.access_token,
    refreshToken: data.refresh_token ?? '',
    sessionId: claims.session_id ?? data.session_id ?? '',
  }
}

export async function loginClient(
  email: string,
  password: string,
  mfaCode?: string
): Promise<AuthLoginResult> {
  try {
    const { data } = await apiClient.post<ClientTokens>('/auth/client/login', {
      email,
      password,
      mfa_code: mfaCode,
    })
    return await validateVaultTokens(data, email)
  } catch (error) {
    throw toServiceError(error)
  }
}

export const isIndependentToken = (token: string) =>
  decodeJwtClaims(token)?.scope === 'client_vault'
